import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../landing/Footer";

export default function RootLayout() {
  const location = useLocation();
  const isWorkspace = location.pathname.startsWith("/workspace");

  return (
    <div className="min-h-screen flex flex-col w-full max-w-full bg-[#FAFAFC] relative overflow-x-hidden">
      <div className="flex-1 flex flex-col w-full max-w-full min-h-0 overflow-x-hidden">
        <Outlet />
      </div>
      <Footer isWorkspace={isWorkspace} />
    </div>
  );
}

